(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-store-reviews-trust"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sd-proof').forEach((section) => {
    if (section.dataset.sliderReady === 'true') return;
    section.dataset.sliderReady = 'true';
    const rail = section.querySelector('[data-review-rail]');
    const move = (direction) => {
      if (!rail) return;
      const card = rail.querySelector('.sd-proof__review');
      rail.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || 300) + 14), behavior: 'smooth' });
    };
    section.querySelector('[data-review-prev]')?.addEventListener('click', () => move(-1));
    section.querySelector('[data-review-next]')?.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();
})();
